const {HMAO, KAREL, KRASN, ORENB, ORLOV, SVERD, SAAS, TATAR, MARIEL, KURGAN, CHUVA, BURYATIA, CHECHNYA, YANAO, CRIMEA, KURSK, PSCOV} = require('./region')

const APP_NAME  = {
  default: 'ТКО',
  [SVERD]: 'ТКО Свердловская область',
  [ORENB]: 'ТКО Оренбургская область',
  [ORLOV]: 'ТКО Орловская область',
  [HMAO]: 'ТКО ХМАО',
  [KRASN]: 'ТКО Краснодарский край',
  [KAREL]: 'ТКО Республика Карелия',
  [SAAS]: 'Муниципальная автоматизированная система обращения с отходами',
  [TATAR]: 'ТКО Республика Татарстан',
  [MARIEL]: 'ТКО Республика Марий Эл',
  [KURGAN]: 'ТКО Курганская область',
  [CHUVA]: 'ТКО Чувашская Республика',
  [BURYATIA]: 'ТКО Республика Бурятия',
  [CHECHNYA]: 'ТКО Чеченская Республика',
  [YANAO]: 'ТКО Ямало-Ненецкий автономный округ',
  [CRIMEA]: 'ТКО Республика Крым',
  [KURSK]: 'ТКО Курская область',
  [PSCOV]: 'ТКО Псковская область'
}

module.exports.APP_NAME = APP_NAME
